"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const icon_1 = __importStar(require("../icon/icon"));
const openExternalLink_1 = __importDefault(require("../openExternalLink/openExternalLink"));
const pressableElement_1 = __importDefault(require("../pressables/pressableElement"));
const text_1 = __importStar(require("../text/text"));
const multiDocumentManagerStyles_1 = __importDefault(require("./multiDocumentManagerStyles"));
const DocumentCard = ({ document, screenName, deleteDocument }) => {
    const navigation = (0, useAppNavigation_1.default)();
    return (react_1.default.createElement(pressableElement_1.default, { key: document.name, style: multiDocumentManagerStyles_1.default.container, onPress: () => (0, openExternalLink_1.default)({
            navigation,
            url: document.url,
            webViewData: {
                sourcePage: screenName,
                sourceScreen: screenName,
                name: 'Document',
                title: 'Document',
            },
        }), eventName: `${screenName}_view_document` },
        react_1.default.createElement(react_native_1.View, { style: multiDocumentManagerStyles_1.default.imageContainer },
            react_1.default.createElement(icon_1.default, { name: icon_1.FILE_ICON })),
        react_1.default.createElement(react_native_1.View, { style: multiDocumentManagerStyles_1.default.fileNameStyle },
            react_1.default.createElement(react_native_1.View, { style: multiDocumentManagerStyles_1.default.fileName },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, document.name))),
            !!deleteDocument && (react_1.default.createElement(react_native_1.View, { style: multiDocumentManagerStyles_1.default.iconStyle },
                react_1.default.createElement(pressableElement_1.default, { onPress: deleteDocument, eventName: `${screenName}_delete_document` },
                    react_1.default.createElement(icon_1.default, { name: icon_1.TRASH_ICON })))))));
};
exports.default = DocumentCard;
